import React, { useState, useEffect, useRef  } from 'react';
import {withRouter, NavLink} from 'react-router-dom';
import moment from 'moment';
import { Nav, NavItem, TabContent, TabPane, Row, Col  } from "reactstrap";
import classnames from "classnames";

import AppLayout from '../../components/AppLayout';
import CreateUpdate from '../../components/managers/manageReadingSigns/CreateUpdate';
import Assign from '../../components/managers/manageReadingSigns/Assign';
import { asyncHandler } from '../../utils';
import Overview from '../../components/managers/manageReadingSigns/Overview';
import { useAppContext } from '../../context';
import apiClient from '../../apiClient';

const ManageReadingSigns = ({
    user
}) => {

    const { setLoading } = useAppContext();
    const [activeFirstTab, setActiveFirstTab] = useState('1');
    const toggleTab = (tab) => setActiveFirstTab(tab);

    const [readingSigns, setReadingSigns] = useState([]);
    const [readingSignRecords, setReadingSignRecords] = useState([]);
    const [readingSignsQuery, setReadingSignsQuery] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesQuery, setEmployeesQuery] = useState(false);
    const [date, setDate] = useState(moment().format('YYYY-MM'));

    const getReadingSignsData = asyncHandler(async() => {
        setLoading(true);
        const res = await apiClient.post(`/getReadingSignsData`, {
            data: {
                units: user.authorizedUnits,
                date
            }
        });

        setLoading(false);
        const { readingSigns, readingSignRecords } = res.data;

        setReadingSigns(readingSigns);
        setReadingSignRecords(readingSignRecords);
        setReadingSignsQuery(true);
    });

    useEffect(() => {
        const getEmployeesForReadingSign = asyncHandler(async() => {
            const res = await apiClient.post(`/getEmployeesForReadingSign`, {
                data: {
                    units: user.authorizedUnits
                }
            });
    
            const users = res.data;
    
            for (let i = 0; i < users.length; i++) {
                users[i].selected = false;
            }
    
            setEmployees(users);
            setEmployeesQuery(true);
        }); 

        if (readingSignsQuery && !employeesQuery) {
            getEmployeesForReadingSign();
        }
    }, [readingSignsQuery, employeesQuery]);

    useEffect(() => {
        getReadingSignsData();
    }, [user.authorizedUnits, date]);

    return (
        <AppLayout>
            <div className={`card queue-card-container`} style={{height: 'calc(100vh - 120px)', overflowY: 'scroll', overflowX: 'hidden'}}>
                <div className="card-body mb-5 px-1 py-1">
                    <Row className='px-3 py-3'>
                        <Col md='12' lg='12'>
                            <Row>
                                <h1 className='pl-3' style={{position: 'relative', top: '6px'}}>Manage Read and Signs</h1>
                            </Row>

                            <Row className='mt-2'>
                                <Col mg='12' lg='12'>
                                    <Nav tabs className="separator-tabs ml-0 mb-2">
                                        <NavItem>
                                            <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active: activeFirstTab === "1",
                                                "nav-link": true
                                            })}
                                            onClick={() => {
                                                toggleTab("1");
                                            }}
                                            >
                                            Overview
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active: activeFirstTab === "2",
                                                "nav-link": true
                                            })}
                                            onClick={() => {
                                                toggleTab("2");
                                            }}
                                            >
                                            Assign
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active: activeFirstTab === "3",
                                                "nav-link": true
                                            })}
                                            onClick={() => {
                                                toggleTab("3");
                                            }}
                                            >
                                            Create/Update
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Col>
                            </Row>

                            <TabContent activeTab={activeFirstTab} className='mt-2'>
                                <TabPane tabId="1">
                                    <Overview 
                                        readingSigns={readingSigns}
                                        readingSignRecords={readingSignRecords}
                                    />
                                </TabPane>
                                <TabPane tabId={'2'}>
                                    <Assign 
                                        employees={employees}
                                        setEmployees={setEmployees}
                                        user={user}
                                        readingSigns={readingSigns}
                                        readingSignRecords={readingSignRecords}
                                        setReadingSignRecords={setReadingSignRecords}
                                    />
                                </TabPane>
                                <TabPane tabId={'3'}>
                                    <CreateUpdate 
                                        user={user}
                                        readingSigns={readingSigns}
                                        setReadingSigns={setReadingSigns}
                                        date={date}
                                        setDate={setDate}
                                    />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </div>

        </AppLayout>
    );
}

export default withRouter(ManageReadingSigns);